module.exports = __webpack_public_path__ + "img/main_architecture_image03_jp.5a752ca0.png";